import { useContext } from 'react';

import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import { KeyboardArrowLeftIcon, KeyboardArrowRightIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { AssetDetailView } from '@atom/types/asset';

import InventoryDetailContext from '../InventoryDetailContext';

import classes from './header.module.css';

const styles = {
  disabled: {
    opacity: '40%',
  },
};

const AssetDetailPagination = () => {
  const {
    asset: { cursor },
  } = useContext(InventoryDetailContext);
  const [{ activeView: viewParam }, { navigate }] = useNavigation();

  const handleChange = (id: string) => {
    const activeView = viewParam || AssetDetailView.ASSET_INFO;
    navigate(`/inventory/${id}?activeView=${activeView}`);
  };

  const isDisabled = cursor.total === 1;

  return (
    <>
      <div className={classes.paginationContainer}>
        {cursor.index + 1} of {cursor.total}
        <IconButton
          disabled={isDisabled}
          onClick={() => handleChange(cursor.previous)}
          data-cy="assetDetailPaginationPreviousButton"
        >
          <Icon
            style={isDisabled ? styles.disabled : {}}
            color={colors.neutral.white}
            icon={KeyboardArrowLeftIcon}
          />
        </IconButton>
        <IconButton
          disabled={isDisabled}
          onClick={() => handleChange(cursor.next)}
          data-cy="assetDetailPaginationNextButton"
        >
          <Icon
            style={isDisabled ? styles.disabled : {}}
            color={colors.neutral.white}
            icon={KeyboardArrowRightIcon}
          />
        </IconButton>
      </div>
      <div className={classes.paginationDivider} />
    </>
  );
};

export default AssetDetailPagination;
